import { render } from "./RecordDetail.vue?vue&type=template&id=a3fcd39a&scoped=true"
import script from "./RecordDetail.vue?vue&type=script&lang=js"
export * from "./RecordDetail.vue?vue&type=script&lang=js"

import "./RecordDetail.vue?vue&type=style&index=0&id=a3fcd39a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3fcd39a"]])

export default __exports__